import styled from 'styled-components'
import {
  FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaTwitter,
} from 'react-icons/fa'
import { usePortfolio } from 'querys/portfolio'

const SocialMediaStyled = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`

function SocialMedia() {
  const {
    data: {
      github_username, facebook_username, instagram_username, twitter_username, linkedin_username,
    },
  } = usePortfolio()

  return (
    <SocialMediaStyled>
      {linkedin_username ? (
        <li>
          <a href={`https://www.linkedin.com/in/${linkedin_username}`} target="_blank" rel="noopener noreferrer">
            <FaLinkedin color="white" size={24} />
          </a>
        </li>
      ) : null}
      {github_username ? (
        <li>
          <a href={`https://github.com/${github_username}`} target="_blank" rel="noopener noreferrer">
            <FaGithub color="white" size={24} />
          </a>
        </li>
      ) : null}
      {facebook_username ? (
        <li>
          <a href={`https://facebook.com/${facebook_username}`} target="_blank" rel="noopener noreferrer">
            <FaFacebook color="white" size={24} />
          </a>
        </li>
      ) : null}
      {instagram_username ? (
        <li>
          <a href={`https://www.instagram.com/${instagram_username}`} target="_blank" rel="noopener noreferrer">
            <FaInstagram color="white" size={24} />
          </a>
        </li>
      ) : null}
      {twitter_username ? (
        <li>
          <a href={`https://twitter.com/${twitter_username}`} target="_blank" rel="noopener noreferrer">
            <FaTwitter color="white" size={24} />
          </a>
        </li>
      ) : null}
    </SocialMediaStyled>
  )
}

export default SocialMedia
